/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { useNotification } from "context/NotificationContext";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";

import dateService from "../../../../../services/dateService";

function Dates(props) {
  const { expedienteId, refreshDates } = props;
  const { showNotification } = useNotification();
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menu, setMenu] = useState(null);
  const [dateId, setDateId] = useState(null);
  const openMenu = (currentTarget,id) => {
    setMenu(currentTarget);
    setDateId(id);
  };

  const closeMenu = () => {
    setMenu(null);
    setDateId(null);
  };

  const handleDelete = async (id) => {
    closeMenu();
    const shouldDelete = window.confirm("¿Realmente desea eliminar este registro?");
    if (shouldDelete) {
        const response = await dateService.deleteDateById(id);
        if (response.success) {
          setDates((prevRows) => prevRows.filter((row) => row.id !== id));
          showNotification("Registro actualizado correctamente", "success");
        } else {
          showNotification("Se ha producido un error", "error");
        }
    }
  };

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      {/* <MenuItem onClick={() => handleCreateDocument(dateId)}>Crear documento</MenuItem> */}
      <MenuItem onClick={() => handleDelete(dateId)}>Eliminar</MenuItem>
    </Menu>
  );

  useEffect(() => {
    async function fetchDates() {
      setLoading(true);
      try {
        const data = await dateService.getDatebyExpedienteId(expedienteId);
        setDates(data);
      } catch (error) {
        showNotification("Error al cargar las fechas", "error");
      } finally {
        setLoading(false);
      }
    }
    fetchDates();
  }, [expedienteId, refreshDates]);


  const listDates = dates.map((dt) => (
    <Grid item xs={12} md={6} xl={3} key={dt.id}>
      <Card>
          <MDBox color="text" p={3} pb={0} display="flex" justifyContent="right" zIndex={1}>
              <Icon
                sx={{ cursor: "pointer", fontWeight: "bold" }}
                fontSize="small"
                onClick={(e) => openMenu(e.currentTarget, dt.id)}
                >
                more_vert
              </Icon>
            </MDBox>
          <MDBox pb={2} mx={3} mt={-3} display="flex" justifyContent="center">
          <MDBox
            display="grid"
            justifyContent="center"
            alignItems="center"
            bgColor={Date.now() < Date.parse(dt.arranged_date) ? "info" : "secondary"}
            color="white"
            width="4rem"
            height="4rem"
            shadow="md"
            borderRadius="lg"
            variant="gradient"
          >
            <Icon fontSize="default">schedule</Icon>
          </MDBox>

        </MDBox>
        <MDBox pb={1} px={2} textAlign="center" lineHeight={1.25}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {dt.arranged_date}
          </MDTypography>
          <MDTypography
            variant="caption"
            fontWeight="regular"
            color="text"
            style={{ whiteSpace: "pre-line" }}
          >
            {dt.link ? dt.link : " - "}
          </MDTypography>
          <MDTypography pt={1} display="block" variant="button" fontWeight="medium">
            PARTE REPRESENTADA
          </MDTypography>
          <MDTypography
            variant="caption"
            fontWeight="regular"
            color="text"
            style={{ whiteSpace: "pre-line" }}
          >
            {dt.entity ? dt.entity : " - "}
          </MDTypography>
          <MDTypography pt={1} display="block" variant="button" fontWeight="medium">
            CONTACTO
          </MDTypography>
          <MDTypography
            variant="caption"
            fontWeight="regular"
            color="text"
            style={{ whiteSpace: "pre-line" }}
          >
            {dt.contact}
          </MDTypography>
          <MDTypography pt={1} display="block" variant="button" fontWeight="medium">
            DESCRIPCIÓN
          </MDTypography>
          <MDTypography
            variant="caption"
            fontWeight="regular"
            color="text"
            style={{ whiteSpace: "pre-line" }}
          >
            {dt.description}
          </MDTypography>
          <Divider />
          <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25} display="flex" justifyContent="center">
            <MDBox>
              <MDTypography variant="caption" fontWeight="regular" color="text">
                Creado {dt.created_date}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </Grid>
  ));

  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" p={2}>
        <CircularProgress size={24} color="info" />
      </MDBox>
    );
  }

  return (
    <MDBox pb={3}>
      <Grid container spacing={3}>
        {listDates}
      </Grid>
      {renderMenu}
    </MDBox>
  );

}

Dates.propTypes = {
    expedienteId: PropTypes.number.isRequired,
    refreshDates: PropTypes.bool,
  };

export default Dates;
